<template>
    <div class="main">正在打开扫一扫....</div>
</template>

<script>
import { Loading } from 'vant';
import { router } from '../router';

export default {
  components: {
    [Loading.name] : Loading
  },
  data() {
    return {
      
    };
  },
  mounted() {
    const { $wechat,  resolveQR } = this;
    $wechat.sdk(sdk => {
      sdk.scanQRCode({
        needResult: 1,
        success: res => {
          resolveQR(res.resultStr);
        }
      })
    });
  },
  methods: {
   resolveQR(qrcode){
     if (qrcode) {
       // 记录用户二维码扫描
        this.$http.post('/member/parking_scan', { qrcode });
        if (qrcode.includes("weixin.qq.com")) {
           router.push('/parking_spot?qrcode='+qrcode);
        } else {
          const devId = qrcode.split(/\?devId=/)[1];
           router.push('/parking_spot?devId='+devId);
        }
        
     }
   }
  }
};
</script>

<style lang="less" scoped>
  .main {
    margin-top: 50px;
    text-align: center;
    color: gray;
    font-size: 12px;
  }
</style>